<script>
     // const BASE_URL = 'http://dental-spe.sublab.cn/';
     const BASE_URL = 'http://njkq.sublab.cn/';
      // const BASE_URL = 'http://192.168.1.123:8088/';
   // const BASE_URL = 'http://192.168.1.123:8088/';
 // const BASE_URL=window.location.protocol+"//"+window.location.host+'/';
    export default{
        BASE_URL
    }
</script>



// WEBPACK FOOTER //
// src/components/Common/Global.vue